const matchArrays = (arrA, arrB) => {
  const equals = (a, b) => JSON.stringify(a) === JSON.stringify(b);
  return equals(arrA, arrB);
};

export default matchArrays;
